import React, { useEffect } from 'react';
// import 'nouislider/distribute/nouislider.css';
import noUiSlider from 'nouislider';
import '../RangePicker.scss';

type Props = {
    questionChoice : object,
    onValueChange: Function,
    sliderOrientation: String
}

// generate diffecte color shades from a hex color
// amount ( 0 - 100 ) ( dark - light )
function adjust(color, amount) {
    return '#' + color.replace(/^#/, '').replace(/../g, color => ('0'+Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)).substr(-2));
}

/** Create light color gradient with actual color provided **/

const getGradientWithLightColor = (deg, color1, value) => {
    

    if (color1 === '#08CF92') {
        return `linear-gradient(${deg}deg, ${color1} ${value - 150}%,${adjust(color1, 60 - value + 160)} 100%)`;
        
    } else {
        return `linear-gradient(${deg}deg, ${color1} ${value - 80}%,${adjust(color1, 100 - value + 50)} 100%)`;
    }
}; 

/** Create color for when circle in center **/

const getGradientWithTwoColors = (color1,color2) => {
    return `linear-gradient(90deg, ${adjust(color1,100)} 10%,#FFFFFF 53%,${adjust(color2,100)} 111%)`;
};

export default function SliderContainer({ questionChoice, onValueChange,sliderOrientation }: Props) {

    useEffect(() => {
        const sliderCustom = document.querySelector(`${window.location.pathname.includes('initquestion') ? '.question-container' : ''} .${questionChoice.unique_key}`); // selection must be pointing to questionnaire question component

        sliderCustom?.noUiSlider?.destroy(); // destroy the no ui slider to rerender
        sliderCustom.innerHTML =
            "<div className='custom-range-picke-container mt-3 mb-3'></div>";
        
        let value;

        if(questionChoice.value !== null && questionChoice.value !== undefined && !isNaN(questionChoice.value)){
            value =   parseInt(questionChoice.value);
        }

        const question = {
            rangeMin: questionChoice.metadata?.min_range || -100,
            rangeMax: questionChoice.metadata?.max_range || 100,
            subType: questionChoice.metadata?.sub_type,
            // subType: "#4A63FF_#F05588", // remove later used for testing -- todo.
            step: 1,
            pipsValues: [],
            pipsText: questionChoice.pipsText,
            value
        };

        const defaultColors = ['#4A63FF', '#F05588']; // defualt color when no usable color is provided to the component

        const subTypeColors = question.subType ? (question.subType.split('_').every((c)=>{return c.startsWith('#');}) ? question.subType.split('_') : defaultColors) : defaultColors;
        
        let colors = subTypeColors;
   
             
        if(subTypeColors.length === 2){
            colors = [subTypeColors[0],getGradientWithTwoColors(subTypeColors[0],subTypeColors[1]),subTypeColors[1]];
        }
        

        const slider = noUiSlider.create(sliderCustom, {
            start: question.value || (question.rangeMin + question.rangeMax) / 2,
            connect: [true, false],
            step: question.step,
            tooltips: question.tooltips,
            pips: {
                mode: question.pipsMode || 'positions',
                values: question.pipsValues.map(function(pVal) {
                    let pipValue = pVal;

                    if (pVal.value !== undefined) {
                        pipValue = pVal.value;
                    }

                    return parseInt(pipValue);
                }),
                density: question.pipsDensity || 5
            },
            range: { min: question.rangeMin, max: question.rangeMax },
            direction: question.direction,
            orientation: sliderOrientation
        });


        const node = document.createElement('div');

        node.classList.add('noUi-connect');
        node.classList.add('noUi-connect-2');
        node.style.width = 0;
        node.style.position = 'absolute';
        node.style.display = 'none';
        const uiBase = sliderCustom.querySelector('.noUi-base');

        uiBase.style.marginTop = '10px !important';

        sliderCustom.style.display = 'flex';

        if (uiBase) {
            uiBase.classList.add('custom-ui-base');
            uiBase.prepend(node);
            const base = document.createElement('div');

            base.classList.add('noUi-connect-base');
            uiBase.prepend(base);
        }

        const horizontal = sliderCustom.querySelector(`.noUi-pips.noUi-pips-${sliderOrientation}`);

        if (horizontal) {
            const pips = [];

            horizontal.querySelectorAll(`.noUi-value.noUi-value-${sliderOrientation}.noUi-value-large`).forEach((el) => {
                if (isNaN(parseInt(sliderCustom.innerHTML)) || parseInt(sliderCustom.innerHTML) === -100 || parseInt(el.innerHTML) === 100) {
                    pips.push(sliderCustom.innerHTML);
                }
            });

            if (pips.length === 2 && sliderCustom) {

                // changed .map() to .forEach() below to remove the eslint warnings.
                pips.forEach((p, i) => {
                    const pip = document.createElement('div');

                    pip.innerHTML = p;

                    if (i === 0) {
                        sliderCustom.prepend(pip);
                    } else {
                        sliderCustom.appendChild(pip);
                    }
                });
            }

            horizontal.style.display = 'none';
        }

        const handles = sliderCustom.querySelector('.noUi-handle.noUi-handle-lower');

        if (handles) {
            handles.classList.add(question.subType || 'blue_pink');

            // changed .map() to .forEach() below to remove the eslint warnings.
            ['touchstart', 'mousedown', 'touchmove', 'click'].forEach(e => {
                handles.addEventListener(e, function() {
                    this.style.transform = 'scale(1.3)';
                    this.style.cursor = 'grabbing';

                    if (this.classList.contains('handle-white')) {
                        this.style.backgroundImage = 'linear-gradient(270deg, #ffaecb 0%, #b1b6ff 100%) !important;';
                    }
                });
            });

            // changed .map() to .forEach() below to remove the eslint warnings.
            ['touchend', 'mouseup', 'blur', 'mouseleave'].forEach(e => {
                document.addEventListener(e, function() {
                    handles.style.transform = 'scale(1)';
                    handles.style.cursor = 'grab';
                });
            });

            // changed .map() to .forEach() below to remove the eslint warnings.
            ['touchend', 'mouseup', 'blur'].forEach(e => {
                handles.addEventListener(e, function() {
                    setTimeout(() => {
                        this.style.transform = 'scale(1)';
                        this.style.cursor = 'grab';
                    }, 0);
                });
            });

            if (question.value === undefined || question.value === null || isNaN(question.value)) {
                handles.style.background = "#FFFF";
            }

            if (parseInt(value) > 0) {   
                handles.style.backgroundImage = getGradientWithLightColor(270,colors[2],Math.floor(value));  
                node.style.backgroundImage = getGradientWithLightColor(270,colors[2],Math.floor(value));
            } else if (parseInt(value) < 0) {
                handles.style.backgroundImage = getGradientWithLightColor(90,colors[0],Math.floor(value)*-1);  
                node.style.backgroundImage = getGradientWithLightColor(270,colors[0],Math.floor(value)*-1);
            }else if(parseInt(value) === 0){
                handles.style.background = colors[1];
            } else {
                node.style.backgroundImage = '';
            }
        }

        slider.on('update', (values, handle, unencoded, tap, positions) => {
            const pos = positions[0];
            const value = parseFloat(values[0]);
            const connect = sliderCustom.querySelectorAll('.noUi-connect:not(.noUi-connect-2)')[0];
            const connect2 = sliderCustom.querySelector('.noUi-connect-2');


            if (handles) {
                if (question.value === undefined || question.value === null || isNaN(question.value)) {
                    handles.style.background = "#FFFFFF"; 
                } else if (question.value === 0 || value === 0) {
                    handles.style.background = colors[1];
                }

                if (connect) {
                    if (value > 0) {
                        handles.style.backgroundImage = getGradientWithLightColor(270,colors[2],Math.floor(value));  
                        node.style.backgroundImage = getGradientWithLightColor(270,colors[2],Math.floor(value)-65);
                        connect.style.backgroundImage = getGradientWithLightColor(270,colors[2],Math.floor(value)-65);

                        connect.style.display = 'block';
                        connect.style.transform = 'scale(1) !important';
                        connect.style.width = `${pos - 50}%`;

                    } else {
                        connect.style.backgroundImage = '';
                        connect.style.display = 'none';
                    }
                }

                if (connect2) {
                    if (value < 0) {
                        const positiveValue = Math.floor(value)*-1;

                        handles.style.backgroundImage = getGradientWithLightColor(90,colors[0],positiveValue);  
                        node.style.backgroundImage = getGradientWithLightColor(-90,colors[0],positiveValue-65);
                        connect2.style.backgroundImage = getGradientWithLightColor(-90,colors[0],positiveValue-65);
                        connect2.style.position ="relative";
                        connect2.style.display = 'flex';
                        connect2.style.left = '50%';
                        connect2.style.transform = 'rotate(180deg) translate(100%,0px)';
                        connect2.style.top = '1px';
                        connect2.style.width = `${50 - pos}%`;
                    } else {
                        connect2.style.backgroundImage = '';
                        connect2.style.display = 'none';
                    }
                }
            }
        });

        slider.on('change', function() {
            const value = Number(slider.get());

            question.value = value;
            onValueChange(value);
        });

        const updateValueHandler = function() {
            slider.set(question.value);
        };

        if (question.isReadOnly) {
            sliderCustom.setAttribute('disabled', true);
        }

        updateValueHandler();
        question.noUiSlider = slider;
        question.valueChangedCallback = updateValueHandler;

        question.readOnlyChangedCallback = function() {
            if (question.isReadOnly) {
                sliderCustom.setAttribute('disabled', true);
            } else {
                sliderCustom.removeAttribute('disabled');
            }
        };
    }, [questionChoice?.value]);

    return <div className='custom-range-picke-container mt-3 mb-3' />;
}
